import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import AttributeSelector from 'components/attributeSelector/Local';
import * as Types from './typings';

interface Props {
  availableRootNodes: Types.rootNodes;
  onChange: (key: string, value: any) => void;
  currentRootNodes: { defaultRootIds: string[] };
}

function RootNodes({ currentRootNodes, availableRootNodes, onChange }: Props) {
  const classes = useStyles();

  const handleSave = (fields: any) => {
    onChange('client.settings.orgChart.defaultRootIds', Object.keys(fields || []));
  };

  const transformedIds = Object.assign(
    {},
    ...currentRootNodes.defaultRootIds.map((name: string) => ({ [name]: true })),
  );
  const getAttributeKey = (attribute: any) => attribute.id;
  const getAttributeDisplayName = (attribute: any) =>
    `${attribute.displayName} (${attribute.totalReportCount} total reports)`;

  const attributesSelectorElem = (
    <AttributeSelector
      label="Configure"
      title="Choose Root Nodes"
      attributes={availableRootNodes}
      selectedAttributes={transformedIds}
      getAttributeKey={getAttributeKey}
      getAttributeDisplayName={getAttributeDisplayName}
      onSaveSelectedAttributes={handleSave}
      classes={{
        attributes: classes.attributesList,
        attributeSelector: classes.attributeSelector,
      }}
      LabelButtonProps={{
        variant: 'contained',
        color: 'secondary',
      }}
      saveButtonLabel="Done"
    />
  );

  return (
    <Card className={classes.cardRoot}>
      <CardHeader
        title="Root Nodes"
        action={attributesSelectorElem}
        subheader="Choose the root nodes (people at the top of your organization) that will always appear
            regardless of who is looking at the Org Chart."
      />
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  cardRoot: {
    overflow: 'visible',
  },
  attributeSelector: {
    maxHeight: 465,
  },
  attributesList: {
    ...theme.typography.body1,
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
}));

export default RootNodes;
